







































import { computed, defineComponent, PropType, useContext } from '@nuxtjs/composition-api';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import TopHorizontalItems from '~/components/pages/Top/TopHorizontalItems.vue';
import TopItemCard from '~/components/pages/Top/TopItemCard.vue';
import AppSeeMoreButton from '~/components/partials/App/AppSeeMoreButton.vue';
import ProductCartSwiper from '~/components/partials/Product/ProductCartSwiper.vue';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { PC } from '~/constants';
import { convertRecommendItems } from '~/utils';
import { GaTopPartsType } from '~/utils/ga';
import { RecommendItem } from '~/types/common/silverEgg';
import { TopItemDetail } from '~/types/modules/top';

export default defineComponent({
  components: {
    TopHorizontalItems,
    ProductCartSwiper,
    AppSeeMoreButton,
    TopItemCard,
    ProductCartButton,
  },
  props: {
    items: {
      type: Array as PropType<TopItemDetail[]>,
      default: () => [],
    },
    silverEggItems: {
      type: Array as PropType<RecommendItem[]>,
      default: () => [],
    },
    rqid: {
      type: String,
      default: '',
    },
    spec: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: 'min-h-[415px]',
    },
    swiperName: {
      type: String,
      default: '',
    },
    gaPartsType: {
      type: String as PropType<GaTopPartsType>,
      default: null,
    },
    gaEventLabel: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const { app } = useContext();
    const isDesktop = computed(() => app.$ua.deviceType() === PC); // 幅1024のipadがあるためUAで判定（ボタン式を避ける）
    const { clickNotify } = useSilverEggApi();
    const convertedItems = computed(() => (props.spec ? convertRecommendItems(props.silverEggItems) : props.items));
    const isUsingSwiper = computed(() => isDesktop.value && convertedItems.value.length > 6);

    const sendClickRequest = async (productCode: string) => {
      if (!props.spec) return;
      await clickNotify({
        itemId: productCode,
        spec: props.spec,
        rqid: props.rqid,
      });
    };

    return {
      isDesktop,
      convertedItems,
      sendClickRequest,
      isUsingSwiper,
    };
  },
});
